import Button from '../ui/Button.jsx';
import { Card, CardBody, CardHeader } from '../ui/Card.jsx';
import HeadingOne from '../ui/HeadingOne.jsx';

const Text = ({ ...props }) => {
    const { icon, heading, subheading, image, text, button, fn } = props;

    return (
        <div className="component-message">
            <HeadingOne icon={icon} heading={heading} />

            <div className="row justify-center">
                <div className="col xl:w-10/12">
                    <Card>
                        <CardHeader heading={subheading} image={'/storage/game/alfa-logo.svg'} />
                        <CardBody>
                            <div className="row items-center justify-center">
                                {image && (
                                    <div className="col lg:w-3/12">
                                        <div className="card-image">
                                            <img src={image} />
                                        </div>
                                    </div>
                                )}
                                <div className="col lg:w-8/12">
                                    <div className={'md:pl-8 lg:pl-12' + (image == undefined ? ' text-center text-balance' : '')}>
                                        <div dangerouslySetInnerHTML={{ __html: text }}></div>

                                        {button && (
                                            <div className="mt-12">
                                                <Button {...button} onClick={() => fn.handleAction(button.action)} />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </div>
            </div>
        </div>
    );
};

export default Text;
